import { destroy, get, put, post } from '../lib/api';

export function getDownloads(growerId, page, pageSize) {
  return get(`/admin/downloads`, { params: { growerId, page, pageSize } });
}

export function getYieldRawFiles(id) {
  return get(`/admin/uploads/yield/${id}/files`);
}

export function getPlantingRawFiles(id) {
  return get(`/admin/uploads/planting/${id}/files`);
}

export function getYieldUploads(growerId, page, pageSize) {
  return get(`/admin/uploads/yield`, { params: { growerId, page, pageSize } });
}

export function getPlantingUploads(growerId, page, pageSize) {
  return get(`/admin/uploads/planting`, {
    params: { growerId, page, pageSize },
  });
}

export function uploadYield(growerId, file) {
  return post(`/admin/uploads/yield`, { growerId, file });
}

export function uploadPlanting(growerId, file) {
  return post(`/admin/uploads/planting`, { growerId, file });
}

export function getFarmqaLayers(aaid) {
  return get(`/admin/farmqa/fields/${aaid}/layers`);
}

export function syncFarmqaLayers(aaid, year) {
  return post(`/admin/farmqa/fields/${aaid}/${year}/sync`);
}

export function getFarmqaFields(id) {
  return get(`/admin/farmqa/operations/${id}/fields`);
}

export function syncFarmqaFields(ids, year) {
  return post(`/admin/farmqa/${year}/fields/sync`, ids);
}

export function getFarmqaOperations() {
  return get(`/admin/farmqa/operations`);
}

export function syncFarmqaOperations(ids, year) {
  return post(`/admin/farmqa/${year}/operations/sync`, ids);
}

export function lookup(searchTerm) {
  return get(`/admin/lookup/${searchTerm}`);
}

export function lookupUploads(aaid) {
  return get(`/admin/uploads/lookup/${aaid}`);
}

export function getFeatureFlags() {
  return get(`/admin/feature-flags`);
}

export function disableFeatureFlag(name, user) {
  return put(`/admin/feature-flags/${name}`, { user, enabled: false });
}

export function enableFeatureFlag(name, user) {
  return put(`/admin/feature-flags/${name}`, { user, enabled: true });
}

export function addFeatureFlag(flag) {
  return post(`/admin/feature-flags`, flag);
}

export function deleteFeatureFlag(flag) {
  return destroy(`/admin/feature-flags/${flag.name}`);
}

export function getExports() {
  return get(`/admin/grower-exports`);
}

export function downloadExports(ids) {
  return post(`/admin/grower-exports`, ids);
}

export function buildExports(growerIds) {
  return put(`/admin/grower-exports`, {
    growerIds: growerIds
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean),
  });
}

export function deleteRawFile(type, id) {
  return destroy(`/admin/uploads/${type}/files/${id}`);
}

export function resendToLeaf(type, id) {
  return post(`/admin/uploads/${type}/${id}/leaf`);
}

export function getSoilCollections(page, pageSize) {
  return get(`/admin/soil/collections`, { params: { page, pageSize } });
}

export function getZohoProducts() {
  return get(`/admin/zoho/products`);
}

export function saveZohoProducts(products) {
  return put(`/admin/zoho/products`, products);
}

export function getHexbins(aaid) {
  return get(`/admin/hexbins/${aaid}`);
}
